import { c as _c } from "react/compiler-runtime";
import React from 'react';
const IconArrowRightWhite = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M10.949 13.206L.708 2.376A1.184 1.184 0 0 1 .718.737a1.088 1.088 0 0 1 1.572.01l11.904 12.589L2.29 24.124a1.092 1.092 0 0 1-1.572-.11 1.188 1.188 0 0 1 .115-1.64l10.115-9.168z" fill="#FFF" fillRule="nonzero" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={15} height={25} viewBox="0 0 15 25" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default IconArrowRightWhite;